import React from 'react';
import classNames from 'classnames';
import { YatLevelDesignation } from '../../../../types';
import type { EmojiId } from '@/client';
import './Emoji.scss';
import { YatSprite } from '@/components/YatSprite';

export interface EmojiProps {
    // TODO: We should have a type for only emojis.
    id: EmojiId;
    level?: YatLevelDesignation;
    listItem?: boolean;
}

export function Emoji({ id, level = YatLevelDesignation.Common, listItem = false }: EmojiProps) {
    const pinClassNames = classNames('Pin-Emoji', {
        // TODO: These should be simplified using a `variationName` utility.
        levelLegendary: level === YatLevelDesignation.Legendary,
        levelEpic: level === YatLevelDesignation.Epic,
    });
    const EmojiTag = listItem ? 'li' : 'div';

    return (
        <EmojiTag className={pinClassNames}>
            <div className="YatSprite-Wrapper">
                <YatSprite forceSprite emojiID={id} />
            </div>
        </EmojiTag>
    );
}
